module.exports = __webpack_public_path__ + "static/media/iconsmind.e46edded.svg";